/* 10-second reorder modal.
 *
 * Adds past-order items to the cart and goes straight to checkout. Deliberately small: the
 * order data is already in the page (see llm-reorder.liquid), so opening is instant and the
 * only network call is the one that matters.
 *
 * The accessibility work here is the same as the hero finder's, for the same reason — an
 * older customer base needs a modal that behaves predictably: Escape closes, focus is trapped
 * and returned, the page behind does not scroll.
 */
(function () {
  /* TWO triggers, one modal: the desktop button lives in the lower menu row, but that row is
     the mobile drill-down container, where it rendered at the top of the screen over the
     header (owner 2026-08-20). Mobile gets its own icon in the icons row instead — the same
     pattern this theme already uses for the help button, and for the same reason. */
  var openBtns = [].slice.call(document.querySelectorAll('.llm-reorder__open'));
  var overlay = document.getElementById('llm-reorder-overlay');
  if (!openBtns.length || !overlay) return;
  var openBtn = openBtns[0];   // fallback for focus return

  /* Portal to <body>. The header sets its own stacking context and z-index; a modal authored
     inside it can never reliably sit above the rest of the page from there. */
  if (overlay.parentElement !== document.body) document.body.appendChild(overlay);

  var dialog = overlay.querySelector('.llm-reorder__dialog');
  var closeBtn = overlay.querySelector('.llm-reorder__close');
  var note = document.getElementById('llm-reorder-note');
  var lastFocused = null;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function open() {
    lastFocused = (document.activeElement && document.activeElement !== document.body)
      ? document.activeElement : openBtn;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var first = dialog.querySelector('.llm-reorder__buy, .llm-reorder__signin-btn') || closeBtn;
    try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
  }

  function close() {
    overlay.hidden = true;
    document.body.style.overflow = '';
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    note.textContent = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  openBtns.forEach(function (b) { b.addEventListener('click', function () { openBtn = b; open(); }); });
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('mousedown', function (e) { if (e.target === overlay) close(); });

  document.addEventListener('keydown', function (e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var items = [].slice.call(dialog.querySelectorAll(FOCUSABLE)).filter(function (el) { return el.offsetParent; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Liquid emits the item list with a trailing comma whenever the LAST line of an order was
     skipped as unavailable, which would make the JSON unparseable. Cleaned here rather than
     contorting the Liquid, which is harder to read and easy to break later. */
  function parseItems(el) {
    var raw = (el.getAttribute('data-items') || '').replace(/,\s*\]/, ']');
    try {
      var items = JSON.parse(raw);
      return Array.isArray(items) ? items.filter(function (i) { return i && i.id; }) : [];
    } catch (e) { return []; }
  }

  /* ---------- attribution ----------
     Until now nothing recorded that a line came from Quick Reorder, so once the order existed it
     was indistinguishable from any other add-to-cart and the feature could not be measured at all.

     A line-item property fixes that with no analytics tool involved: the LEADING UNDERSCORE hides
     it from the customer everywhere it would otherwise be displayed (cart, checkout, confirmation
     email, packing slip), while it persists onto the order forever and is queryable as
     `lineItem.customAttributes`. That beats an events pipeline for this question — it is tied to
     real orders and real revenue, survives ad blockers, and can be queried retroactively.

     ⚠️ Known side effect: a line carrying a property will NOT merge with the same variant added
     without one, so reordering a product and then adding it again normally produces two cart lines.
     Accepted deliberately — the alternative (a cart-level attribute) would tag the whole order
     including items that had nothing to do with reorder, which overstates the feature. */
  var SOURCE = 'quick-reorder';

  function tag(items) {
    return items.map(function (i) {
      var props = {};
      for (var k in (i.properties || {})) props[k] = i.properties[k];
      props._source = SOURCE;
      return { id: i.id, quantity: i.quantity, properties: props };
    });
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: tag(items) }),
    }).then(function (r) {
      if (r.ok) return r.json();
      /* A variant can sell out between page render and click. Report which one, rather than
         a generic failure the customer can do nothing with. */
      return r.json().then(function (err) {
        throw new Error((err && err.description) || 'Some items could not be added.');
      }, function () { throw new Error('Some items could not be added.'); });
    });
  }

  dialog.addEventListener('click', function (e) {
    var buy = e.target.closest('.llm-reorder__buy');
    var add = e.target.closest('.llm-reorder__add');
    var btn = buy || add;
    if (!btn) return;

    var items = parseItems(btn);
    if (!items.length) { note.textContent = 'Nothing in that order is available to buy right now.'; return; }

    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    note.textContent = '';

    addToCart(items).then(function () {
      if (buy) {
        /* Straight to checkout: this is the whole point of the feature. Shop Pay fills the
           address and card from there for returning customers. */
        btn.textContent = 'Going to checkout…';
        window.location.href = '/checkout';
        return;
      }
      btn.textContent = 'Added ✓';
      note.textContent = 'Added to your cart.';
      refreshCartUi();
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2500);
    }).catch(function (err) {
      btn.textContent = label;
      btn.disabled = false;
      note.textContent = err.message;
    });
  });

  /* Keep the header count and drawer honest — the same theme wiring the collection helper
     uses, since a silent cart change reads as nothing having happened. */
  function refreshCartUi() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.refresh === 'function') drawer.refresh(true);
    }).catch(function () {});
  }
})();
